exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-15737711]{border:1px solid #939393!important;border-radius:0}.card-header[data-v-15737711]{border:0;background-color:#fff;padding:0}button[data-v-15737711]{box-shadow:none!important;outline:none!important;font-weight:600}.form-check-label[data-v-15737711]{font-size:smaller}", ""]);

// exports
